import { t } from 'utils/translates';
import ByEarnMoney from '../ByEarnMoney';
// import ByAds from '../ByAds';
import ByExp from '../ByExp';
import ByReferrals from '../ByReferrals';

export const getTopListsMap = () => ({
  'by-earn-money': {
    iconClass: `fa fa-briefcase`,
    name: t('По заработку'),
    component: ByEarnMoney,
    reducerName: 'topUsersModule.lists.topUsersOfEarningsList'
  },
  /* 'by-ads': {
    iconClass: `fa fa-bar-chart-o`,
    name: `По рекламе`,
    component: ByAds,
    reducerName: 'topUsersModule.lists.topUsersOfAdvertisingList'
  }, */
  'by-exp': {
    iconClass: `fa fa-star`,
    name: t('По опыту'),
    component: ByExp,
    reducerName: 'topUsersModule.lists.topUsersOfExperienceList'
  },
  'by-referrals': {
    iconClass: `fa fa-group`,
    name: t('По рефералам'),
    component: ByReferrals,
    reducerName: 'topUsersModule.lists.topUsersOfReferralsList'
  }
});

export default null;



// WEBPACK FOOTER //
// ./src/components/TopUsers/_common/topListsMap.js